import React, { useEffect, useState } from "react";
import axios from "axios";
import { parseAxiosError } from "../../../../utils/response";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import GoToBackButton from "../../../elements/goToBack/GoToBack";
import Notification from "../../../elements/notification/Notification";
import { useHistory } from "react-router-dom";
import { checkFilterItem, fetchFilterData } from "../../../../utils/fetchFilterData";
import { Helmet } from "react-helmet-async";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../../utils/consts";
import { useTranslation } from "react-i18next";
import { StyledLogsWrapper } from "../../../logs/styledLogs";
import { StyledContentWrapper } from "../../../styles/styledMain";
import { StyledMasterBalancesHistoryWrapper } from "../../styledMasterBalances";
import MasterBalancesHistoryList from "./MasterBalancesHistoryList";

const MasterBalancesHistoryContainer = ({ match }) => {
  const { t } = useTranslation("masterBalancesPage");
  const [balanceHistory, setBalanceHistory] = useState([]);
  const [loading, setLoading] = useState({
    main: false,
    fragment: false
  });

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true)
  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchBalanceHistory = () => {
    let itemsPerPage;

    if (balanceHistory.length === 0) {
      setLoading({ main: true, fragment: false });
      itemsPerPage = 100;
    } else {
      setLoading({ main: false, fragment: true });
      itemsPerPage = 30;
    }

    let filterUrl = fetchFilterData(filterData);

    history.replace(filterUrl);

    const otherFilterData = "&itemsPerPage=" + itemsPerPage

    axios.get(`/api/master-balances/${match.params.id}/history` + filterUrl + otherFilterData, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        let requestData = response.data.list;

        if (response.data.page === 1) {
          setBalanceHistory(requestData);
          return;
        }

        setBalanceHistory([...balanceHistory, ...requestData]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    }).finally(() => setLoading({ main: false, fragment: false }));
  };

  useEffect(() => {
    fetchBalanceHistory();

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [filterData]);

  const onScroll = () => {
    const scrollTop = document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;

    if (Math.ceil(scrollTop + clientHeight) >= scrollHeight) {
      setFilterData({ ...filterData, page: filterData.page + 1 });
    }
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <Helmet>
          <title>{t("meta.title")}</title>
        </Helmet>
        <StyledMasterBalancesHistoryWrapper>
          <GoToBackButton
            pt="20"
            pb="30"
            handler={() => {history.goBack();}}
          />
          <MasterBalancesHistoryList
            t={t}
            loading={loading}
            balanceHistory={balanceHistory}
          />
        </StyledMasterBalancesHistoryWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default MasterBalancesHistoryContainer;